<template>
  <v-card
    style="flex: 1; margin-top: 10px; margin-left: 10px; margin-right: 5px"
  >
    <div style="display: flex; margin-top: 10px">
      <!-- NOMBRE DE SITE -->
      <div style="flex: 1; min-width: 0">
        <span class="titledashboard">{{ $t("_nombre_de_site_") }}</span>
        <div
          style="
            margin-left: 10px;
            justify-content: center;
            display: flex;
            align-items: center;
            margin-top: 10px;
          "
        >
          <span
            style="
              font-size: 30px;
              font-weight: bold;
              margin-top: 5px;
              margin-bottom: 5px;
            "
          >
            {{ liste_dashboard.nb_de_site || 0 }}
          </span>
        </div>
      </div>

      <!-- ROI EURO OPTIM -->
      <div class="containerdashboardClean">
        <v-menu
          v-model="showRoiOptimMenu"
          offset-x
          transition="scale-transition"
          :close-on-content-click="false"
        >
          <template v-slot:activator="{ on, attrs }">
            <div
              style="cursor: pointer; width: 100%; height: 100%"
              v-bind="attrs"
              v-on="on"
            >
              <v-tooltip bottom>
                <template
                  v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }"
                >
                  <span
                    class="titledashboard"
                    v-bind="tooltipAttrs"
                    v-on="tooltipOn"
                  >
                    {{ $t("_roi_euro_optim_") }}
                  </span>
                </template>

                <span>
                  {{ $t("_roi_euro_optim_hover_") }}
                </span>
              </v-tooltip>

              <div
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  gap: 18px;
                  margin-top: 10px;
                "
              >
                <span style="font-size: 30px; font-weight: bold">
                  {{ (Math.round((liste_dashboard.roi_euro_optim || 0) / 100) * 100).toLocaleString("fr-FR") }} €
                </span>
              </div>
            </div>
          </template>

          <v-card width="280">
            <v-treeview :items="roiOptimTree" dense open-on-click>
              <template v-slot:label="{ item }">
                {{ $t(item.name) }}
              </template>

              <template v-slot:append="{ item }">
                <b> {{ Math.round((item.value|| 0) / 100) * 100 }} €</b>
              </template>
            </v-treeview>
          </v-card>
        </v-menu>
      </div>

      <!-- FLEET LOSSES PCT -->
      <div class="containerdashboardCleantwo">
        <v-menu
          v-model="showFleetLossMenu"
          offset-x
          transition="scale-transition"
          :close-on-content-click="false"
        >
          <template v-slot:activator="{ on, attrs }">
            <div
              style="cursor: pointer; width: 100%; height: 100%"
              v-bind="attrs"
              v-on="on"
            >
              <v-tooltip bottom>
                <template
                  v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }"
                >
                  <span
                    class="titledashboard"
                    v-bind="tooltipAttrs"
                    v-on="tooltipOn"
                  >
                    {{ $t("_Fleet_losses_pct_") }}
                  </span>
                </template>

                <span>
                  {{ $t("_Fleet_losses_pct_hover_") }}
                </span>
              </v-tooltip>
              <div
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  gap: 8px;
                  margin-top: 10px;
                "
              >
                <span style="font-size: 20px; font-weight: bold; margin-left: 30px;">
                  {{ liste_dashboard.Fleet_losses_pct || 0 }}%
                </span>

                <div>
                  <div>
                    <span style="font-size: 18px; margin-left: 20px;">
                      {{ liste_dashboard.Fleet_losses_evolutions_pct || 0 }} %
                    </span>

                    <v-icon
                      v-if="liste_dashboard.Fleet_losses_evolutions_pct > 2"
                      color="#FA4C4C"
                    >
                      mdi-arrow-top-right
                    </v-icon>

                    <v-icon
                      v-else-if="
                        liste_dashboard.Fleet_losses_evolutions_pct > 0
                      "
                      color="orange"
                    >
                      mdi-arrow-top-right
                    </v-icon>

                    <v-icon
                      v-else-if="
                        liste_dashboard.Fleet_losses_evolutions_pct < 0
                      "
                      color="#12D600"
                    >
                      mdi-arrow-bottom-right
                    </v-icon>
                  </div>

                  <div style="font-size: 12px; margin-left: 10px;">
                    {{ $t("_Fleet_losses_evolutions_pct_") }}
                  </div>
                </div>
              </div>
            </div>
          </template>

          <v-card width="280">
            <v-treeview :items="alarmLossTree" dense activatable open-on-click>
              <template v-slot:label="{ item }">
                {{ $t(item.name) }}
              </template>

              <template v-slot:append="{ item }">
                <b>{{ item.value || 0 }} %</b>
              </template>
            </v-treeview>
          </v-card>
        </v-menu>
      </div>

      <!-- ALARM INFO -->
      <div class="containerdashboardCleantwo">
        <span class="titledashboard" style="font-size: 15px">{{
          $t("_info_alarmes_")
        }}</span>
        <div class="dashboard-content">
          <div class="icon-container">
            <div class="icon-item">
              <v-icon color="#44FF79" small>mdi-circle</v-icon>
              <span class="icon-label"
                >{{ $t("_sites_sans_alarmes_") }}: {{ total }}</span
              >
            </div>
            <div class="icon-item">
              <v-icon color="#FFA500" small>mdi-circle</v-icon>
              <span class="icon-label"
                >{{ $t("_alarmes_severe_") }}: {{ minor_alarms }}</span
              >
            </div>
            <div class="icon-item">
              <v-icon color="#FA4C4C" small>mdi-circle</v-icon>
              <span class="icon-label"
                >{{ $t("_alarmes_critique_") }}: {{ major_alarms }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="display: flex; margin-top: 20px; margin-bottom: 10px">
      <!-- PUISSANCE CRETE -->
      <div style="flex: 1; min-width: 0">
        <span class="titledashboard">{{ $t("_puissance_crete_(mwc)_") }}</span>
        <div
          style="
            margin-left: 10px;
            justify-content: center;
            display: flex;
            align-items: center;
            margin-top: 10px;
            margin-bottom: 15px;
          "
        >
          <span
            style="
              font-size: 30px;
              font-weight: bold;
              margin-top: 5px;
              margin-bottom: 5px;
            "
          >
            {{
              liste_dashboard.pc_totale
                ? liste_dashboard.pc_totale.toFixed(1)
                : "0.0"
            }}
            <span style="font-weight: normal">{{ $t("_mwc_") }}</span>
          </span>
        </div>
      </div>

      <!-- ROI EURO USER -->
      <div class="containerdashboardClean">
        <v-menu
          v-model="showRoiUserMenu"
          offset-x
          transition="scale-transition"
          :close-on-content-click="false"
        >
          <template v-slot:activator="{ on, attrs }">
            <div
              style="cursor: pointer; width: 100%; height: 100%"
              v-bind="attrs"
              v-on="on"
            >
              <v-tooltip bottom>
                <template
                  v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }"
                >
                  <span
                    class="titledashboard"
                    v-bind="tooltipAttrs"
                    v-on="tooltipOn"
                  >
                    {{ $t("_roi_euro_user_") }}
                  </span>
                </template>

                <span>
                  {{ $t("_roi_euro_user_hover_") }}
                </span>
              </v-tooltip>

              <div
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  gap: 18px;
                  margin-top: 10px;
                "
              >
                <span style="font-size: 30px; font-weight: bold">
                  {{ (Math.round((liste_dashboard.roi_euro_user || 0) / 100) * 100).toLocaleString("fr-FR") }} €
                </span>
              </div>
            </div>
          </template>

          <v-card width="280">
            <v-treeview :items="roiUserTree" dense open-on-click>
              <template v-slot:label="{ item }">
                {{ $t(item.name) }}
              </template>

              <template v-slot:append="{ item }">
                <b>{{Math.round((item.value || 0) / 100) * 100}} €</b> 
              </template>
            </v-treeview>
          </v-card>
        </v-menu>
      </div>

      <!-- FLEET RECOVERABLES LOSSES PCT -->
      <div class="containerdashboardCleantwo">
        <v-menu
          v-model="showActionLossMenu"
          offset-x
          transition="scale-transition"
          :close-on-content-click="false"
        >
          <template v-slot:activator="{ on, attrs }">
            <div
              style="cursor: pointer; width: 100%; height: 100%"
              v-bind="attrs"
              v-on="on"
            >
              <v-tooltip bottom>
                <template
                  v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }"
                >
                  <span
                    class="titledashboard"
                    v-bind="tooltipAttrs"
                    v-on="tooltipOn"
                  >
                    {{ $t("_Fleet_recoverables_losses_pct_") }}
                  </span>
                </template>

                <span>
                  {{ $t("_Fleet_recoverables_losses_pct_hover_") }}
                </span>
              </v-tooltip>

              <div
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  gap: 18px;
                  margin-top: 10px;
                "
              >
                 <span style="font-size: 20px; font-weight: bold; margin-left:30px;">
                  {{ liste_dashboard.Fleet_recoverables_losses_pct || 0 }}%
                </span>

                <div>
                  <div>
                    <span style="font-size: 18px; margin-left: 20px;">
                      {{
                        liste_dashboard.Fleet_recoverable_losses_evolutions_pct ||
                        0
                      }}
                      %
                    </span>

                    <v-icon
                      v-if="
                        liste_dashboard.Fleet_recoverable_losses_evolutions_pct >
                        2
                      "
                      color="#FA4C4C"
                    >
                      mdi-arrow-top-right
                    </v-icon>

                    <v-icon
                      v-else-if="
                        liste_dashboard.Fleet_recoverable_losses_evolutions_pct >
                        0
                      "
                      color="orange"
                    >
                      mdi-arrow-top-right
                    </v-icon>

                    <v-icon
                      v-else-if="
                        liste_dashboard.Fleet_recoverable_losses_evolutions_pct <
                        0
                      "
                      color="#12D600"
                    >
                      mdi-arrow-bottom-right
                    </v-icon>
                  </div>

                  <div style="font-size: 12px; margin-left: 10px;">
                    {{ $t("_Fleet_recoverable_losses_evolutions_pct_") }}
                  </div>
                </div>
              </div>
            </div>
          </template>

          <v-card width="280">
            <v-treeview :items="actionLossTree" dense activatable open-on-click>
              <template v-slot:label="{ item }">
                {{ $t(item.name) }}
              </template>

              <template v-slot:append="{ item }">
                <b>{{ item.value || 0 }} %</b>
              </template>
            </v-treeview>
          </v-card>
        </v-menu>
      </div>

      <div class="containerdashboardCleantwo">
        <div
          ref="myChartContainer6"
          style="
            width: 100%;
            max-width: 150px;
            margin-bottom: 5px;
            margin-left: 20%;
            margin-top: 5%;
          "
        ></div>
      </div>
    </div>
  </v-card>
</template>

<script>
import Chart from "chart.js";

export default {
  props: {
    liste_dashboard: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    alarmsByInstallation: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      chartalarmes: null,
      menuStyle: {},
      showRoiOptimMenu: false,
      showRoiUserMenu: false,
      showFleetLossMenu: false,
      showActionLossMenu: false,
      roiUserTree: [],
      roiOptimTree: [],
      alarmLossTree: [],
      actionLossTree: [],
      total: 0,
      major_alarms: 0,
      minor_alarms: 0,
    };
  },

  mounted() {
    this.createChart();
    this.$nextTick(() => {
      this.updateChart();
    });
  },

  watch: {
    liste_dashboard: {
      handler(newVal) {
        if (!newVal || Object.keys(newVal).length === 0) return;

        // Populate treeviews dynamically from total payload
        if (newVal.roiUserTree) this.roiUserTree = newVal.roiUserTree;
        if (newVal.roiOptimTree) this.roiOptimTree = newVal.roiOptimTree;
        if (newVal.Fleet_losses_pct_tree) {
          this.alarmLossTree = newVal.Fleet_losses_pct_tree;
        }
        if (newVal.Fleet_recoverables_losses_pct_tree) {
          this.actionLossTree = newVal.Fleet_recoverables_losses_pct_tree;
        }
      },
      immediate: true,
      deep: true,
    },
    alarmsByInstallation: {
      handler(newVal) {
        if (!newVal || Object.keys(newVal).length === 0) {
          this.major_alarms = 0;
          this.minor_alarms = 0;
          this.total = 0;
          this.updateChart();
          return;
        }
        this.major_alarms = newVal.major_alarms || 0;
        this.minor_alarms = newVal.minor_alarms || 0;
        this.total = newVal.no_alarm_found || 0;
        this.updateChart();
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    createChart() {
      if (!this.$refs.myChartContainer6) return;

      const ctx6 = document.createElement("canvas");
      this.$refs.myChartContainer6.appendChild(ctx6);

      const yValues = [35, 35, 30];
      const barColors = ["#44FF79", "#FFA500", "#FA4C4C"];

      this.chartalarmes = new Chart(ctx6, {
        type: "doughnut",
        data: {
          datasets: [
            {
              backgroundColor: barColors,
              borderWidth: 0,
              data: yValues,
            },
          ],
        },
        options: {
          cutoutPercentage: 75,
          legend: {
            display: false,
          },
          tooltips: {
            enabled: false,
          },
        },
      });
    },

    updateChart() {
      let majorAlarms = this.major_alarms || 0;
      let minorAlarms = this.minor_alarms || 0;
      let withoutAlarms = this.total || 0;
      let totalAlarms = withoutAlarms + majorAlarms + minorAlarms;

      let nbrWithout =
        totalAlarms > 0 ? (withoutAlarms / totalAlarms) * 100 : 0;
      let nbrMajor = totalAlarms > 0 ? (majorAlarms / totalAlarms) * 100 : 0;
      let nbrMinor = totalAlarms > 0 ? (minorAlarms / totalAlarms) * 100 : 0;

      if (this.chartalarmes && this.chartalarmes.data) {
        this.chartalarmes.data.datasets[0].data[0] = nbrWithout;
        this.chartalarmes.data.datasets[0].data[1] = nbrMinor;
        this.chartalarmes.data.datasets[0].data[2] = nbrMajor;
        this.chartalarmes.update();
      }
    },
  },
};
</script>

<style scoped>
.titledashboard {
  margin-left: 10px;
  font-size: 13px;
  font-weight: bold;
}

.containerdashboardClean,
.containerdashboardCleantwo {
  flex: 1;
  min-width: 0;
  border-left: 3px solid black;
}

.dashboard-content {
  display: flex;
  align-items: flex-start;
  margin-top: 5px;
  margin-left: 10px;
}

.icon-container {
  display: flex;
  flex-direction: column;
  margin-left: 30px;
}

.treeview-container {
  max-height: 300px;
  overflow-y: auto;
}
.v-menu__content {
  min-width: 280px !important;
}

.icon-item {
  display: flex;
  align-items: center;
  margin-bottom: 2px;
}

.icon-label {
  margin-left: 5px;
  font-size: 13px;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.6);
}
</style>
